module.exports = __webpack_public_path__ + "static/media/milky-way-ai-logo.7bdf6396.svg";